import React, {Fragment, useEffect,useState} from 'react';
import { Outlet } from 'react-router-dom';
import Loader from '../component/common/loader';
import Header from '../component/Header/Header';
import Footer from '../component/Footer/Footer';
import ProfileHeader from "../component/ProfileHeader/ProfileHeader";
import ProfileSidebar from "../component/ProfileSidebar/ProfileSidebar";
import PublicProfileSidebar from '../component/PublicProfileSidebar/PublicProfileSidebar';
import path from '../routes/path'
import './scss/ProfileLayot.scss'
import {courseAction} from "../store/courseSlice";
import {useDispatch} from "react-redux";

const ProfileLayout = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        if (!window.location.href.toString().includes("/courses-list-new"))
            dispatch(courseAction.setSearchParam(""));
    }, [window.location.href]);

    const [profileMenuOpen,setProfileMenuOpen] = useState(false);

    return(
        <Fragment>
        <div className="profile-wrapper">
            <Header />
            <div className="profile-layout-full">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            {
                                window.location.pathname === path.view_public_profile || window.location.pathname === path.public_profile_courses ? (
                                    <PublicProfileSidebar
                                        profileMenuOpen={profileMenuOpen}
                                        setProfileMenuOpen={setProfileMenuOpen}
                                    />
                                ) : (
                                    <ProfileSidebar
                                        profileMenuOpen={profileMenuOpen}
                                        setProfileMenuOpen={setProfileMenuOpen}
                                    />
                                )
                            }
                        </div>
                        <div className="col-lg-9">
                            <ProfileHeader
                                profileMenuOpen={profileMenuOpen}
                                setProfileMenuOpen={setProfileMenuOpen}
                            />
                            <Outlet /> 
                            <Loader />
                        </div>
                    </div>
                </div>
                
            </div>
            <Footer />
        </div>
        </Fragment>
    )
}
export default ProfileLayout;